import { arePrescriptionsForDoctorOnly } from "@/services/config";
import store from "@/store";

const canAccessPrescription = () => {
  if (arePrescriptionsForDoctorOnly) {
    return store.getters.isDoctor;
  }
  return !store.getters.isDoctor;
};

const prescriptionRoutes = [
  {
    path: "/prescription",
    name: "prescription",
    meta: {
      condition: canAccessPrescription,
      redirectTo: { name: "home" },
    },
    component: () =>
      import(
        /* webpackChunkName: "prescription" */ "../components/prescription/Prescription.vue"
      ),
  },
  {
    path: "/patient-prescription-request",
    name: "patient-prescription-request",
    component: () =>
      import(
        /* webpackChunkName: "prescription" */ "../components/prescription/PatientPrescriptionRequest.vue"
      ),
  },
  {
    path: "/prescription-queue",
    name: "prescription-queue",
    component: () =>
      import(
        /* webpackChunkName: "prescription" */ "../components/prescription/PrescriptionQueue.vue"
      ),
  },
  {
    path: "/prescription-queue/history",
    name: "prescription-history",
    component: () =>
      import(
        /* webpackChunkName: "prescription" */ "../components/prescription/PrescriptionHistory.vue"
      ),
  },
];

export default prescriptionRoutes;
